import { Icon } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import { draggableMultiValueLabelStyles } from 'client/js/common/components/core/PureQueryBuilder/DraggableCompareBy/styles';
import type { DropdownOption } from 'client/js/main/types/dropdownTypes';
import React from 'react';
import type { MultiValueGenericProps } from 'react-select';
import { components } from 'react-select';
import ConflictIcon from './ConflictIcon';
import styles from './MultiValueLabel.styles';

type Props = MultiValueGenericProps<DropdownOption> & { draggable?: boolean };

const MultiValueLabel = (props: Props) => {
  const blockedDimension = props.selectProps.blockedDimensions?.find((currentBlockedDimension) => {
    return currentBlockedDimension.dimensions.includes(props.data.value);
  });

  let option: { label: string; value: string } | null = null;

  if (blockedDimension) {
    option = props.selectProps.options.find((currentOption) => {
      return currentOption.value === blockedDimension.blockedBy;
    });
  }

  props.innerProps.className = `${props.innerProps.className} Select-value-label`;

  return (
    <div className={draggableMultiValueLabelStyles.container}>
      {props.draggable && <Icon className={cx(draggableMultiValueLabelStyles.dragIcon, 'drag-icon')}>drag_indicator</Icon>}
      {option ? (
        <div className={styles.iconWrapper}>
          <ConflictIcon relatedMetrics={props.selectProps.relatedMetrics} conflictingDimensionName={option.label} />
        </div>
      ) : (
        ''
      )}
      <div className={styles.labelValue}>
        <components.MultiValueLabel {...props} />
      </div>
    </div>
  );
};

export default MultiValueLabel;
